import React, { createContext, useContext, useState } from 'react';

const MyContext = createContext();

export const ProviderForMyApp = ({ children }) => {
 
    const [Storage,SetStorage] = useState({
        mobilenumber:null,
        sessionid:null,
        selectedbank:null,
        Socketconnnection:null,
        userid:null,
        consentHandle:null,
        AccountLinkingReferNumber:null,
        finalConsentApproval:false,
        userData:null,
        consentpending:false,
        internalservererror:false,
        redirecttounderreview:false

    });
 
  return (
    <MyContext.Provider value={{ Storage,SetStorage}}>
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);
